import script from "./RefinerButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefinerButton.vue?vue&type=script&setup=true&lang=ts"

import "./RefinerButton.vue?vue&type=style&index=0&id=1d2735d8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2735d8"]])

export default __exports__